<script setup>
  import * as Auth from '@/services/Auth'
</script>

<template>
  <main>
    <v-container>
      <div v-if="!Auth.isAuthenticated()">
        <div class="d-flex justify-center align-center my-12">
          <v-card max-width="600" class="text-center pa-8" elevation="8">
            <v-icon size="80" color="primary" class="mb-4">mdi-flag-checkered</v-icon>
            
            <h1 class="text-h4 mb-4">{{ $t('app.welcomeTitle') }}</h1>
            
            <p class="text-medium-emphasis mb-6">
              {{ $t('app.welcomeMessage') }}
            </p>

            <v-btn
              :to="{ name: 'login' }"
              color="primary"
              size="x-large"
              variant="elevated"
              class="px-12"
            >
              <v-icon start>mdi-login</v-icon>
              {{ $t('common.login') }}
            </v-btn>
          </v-card>
        </div>
      </div>

      <div v-else>
        <v-card class="mt-8 mb-6" elevation="0" color="transparent">
          <v-card-text class="text-center">
            <h2 class="text-h4 mb-3">{{ $t('app.welcomeTitle') }}</h2>
            <p class="text-body-1 text-medium-emphasis">
              {{ $t('app.welcomeMessage') }}
            </p>
          </v-card-text>
        </v-card>

        <v-row justify="center" class="mb-8">
          <v-col cols="12" md="4">
            <v-card
              :to="{ name: 'play' }"
              hover
              class="text-center pa-6"
              elevation="2"
            >
              <v-icon size="48" color="primary" class="mb-3">mdi-bicycle-cargo</v-icon>
              <v-card-title class="justify-center">{{ $t('app.playTitle') }}</v-card-title>
              <v-card-text class="text-medium-emphasis">
                {{ $t('app.playDescription') }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>


    </v-container>
  </main>
</template>
